module.exports = __webpack_public_path__ + "img/resources.15a884bb.jpeg";